import { type GetCountryValue } from "../../common/components/CountrySelectionDropDown";
import { PaymentMethod } from "../../common/types/enums";
import { type PaymentMethodEnum as PaymentMethodEnumType } from "../../graphql/supergraph.index";
import { PaymentMethodEnum } from "../../graphql/supergraphOperations";
import { type PaymentMethodValue } from "./Context/types";

export const getCountryValue: GetCountryValue = ({ id, name }) => `${name}:${id}`;

export const mapCountryToValueSafely = (id?: string, name?: string): string =>
  id && name ? `${name}:${id}` : "";

export const getNameFromCountry = (country?: string | null) =>
  country?.substring(0, country.indexOf(":"))?.trim() ?? "";

export const getIdFromCountry = (country?: string) =>
  country?.substring(country.indexOf(":") + 1)?.trim() ?? "";

export const getAvailablePaymentMethods: (input: {
  availablePaymentMethods: PaymentMethodEnumType[];
}) => Record<PaymentMethod, PaymentMethodValue> = ({
  availablePaymentMethods,
}: {
  availablePaymentMethods: PaymentMethodEnumType[];
}) => {
  return {
    [PaymentMethod.ACH]: {
      isAvailable: availablePaymentMethods.includes(PaymentMethodEnum.Ach),
      warning: "",
    },
    [PaymentMethod.Wire]: {
      isAvailable: availablePaymentMethods.includes(PaymentMethodEnum.Wire),
      warning: "",
    },
    [PaymentMethod.Check]: {
      isAvailable: availablePaymentMethods.includes(PaymentMethodEnum.Check),
      warning: "",
    },
  };
};
